export default "__VITE_ASSET__C6eNzF$b__"